import styled from "styled-components"; 

export const ContainerTableGlobal = styled.div`
    width: ${({width}) => `${width}px`};
    height: 600px;
    border: 1px solid black; 
    
`;